/* eslint-disable react-redux/prefer-separate-component-file */
import React from "react";
import { connect, MapStateToProps } from "react-redux";

import { BackgroundColorWrapper } from "@multiweb/reactComponents";
import { createGetBackgroundAttributeColor } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { AttributeComponent, AttributeProps } from "../types";
import { ConnectedAttributeHOCProps } from "./connectAttribute";

type StateProps = Pick<AttributeProps, "backgroundAttributeColor">;

const createMapStateToProps: () => MapStateToProps<StateProps, ConnectedAttributeHOCProps, IAppState> = () => (
    state,
    { dataSourceKey, recordId, attributeName },
) => {
    const getBackgroundAttributeColor = createGetBackgroundAttributeColor();

    return {
        backgroundAttributeColor: getBackgroundAttributeColor(state, { dataSourceKey, attributeName, recordId }),
    };
};

/**
 * HOC, která obalí atribut pozadím.
 *
 * @param Attribute Komponenta atributu
 * @param enableBackgroundColor
 */
export const withBackgroundAttr = (
    AttributeComponent: AttributeComponent,
    enableBackgroundColor: boolean = true,
) => {
    const ConnectedAttributeHOC: AttributeComponent = (props) => {
        const { backgroundAttributeColor } = props;
        if (enableBackgroundColor && backgroundAttributeColor) {
            return (
                <BackgroundColorWrapper color={backgroundAttributeColor}>
                    <AttributeComponent {...props } hasBackgroundAttr={true} />
                </BackgroundColorWrapper>
            );
        } else {
            return (<AttributeComponent {...props} />);
        }
    };

    return connect(createMapStateToProps)(ConnectedAttributeHOC);
};
